import { useRouter } from "next/router";
import { useEffect } from "react";
import { getReferrerReturnPath, isViewerPath, rememberViewerReturnPath, shouldUseReferrerReturnPath } from "../utils/viewerReturnPath";

/**
 * Records the page the user opened the viewer from, so the viewer's back
 * action returns there. Soft navigations into the viewer record the current
 * page; a fresh full page load straight into the viewer (e.g. from
 * qtrack-lc) records document.referrer instead, while a reload keeps the
 * value already remembered.
 */
function useViewerReturnPath() {
  var router = useRouter();
  useEffect(function () {
    var _window$performance, _window$performance$g;
    var navigationEntry = (_window$performance = window.performance) === null || _window$performance === void 0 || (_window$performance$g = _window$performance.getEntriesByType) === null || _window$performance$g === void 0 || (_window$performance$g = _window$performance$g.call(_window$performance, "navigation")) === null || _window$performance$g === void 0 ? void 0 : _window$performance$g[0];
    if (isViewerPath(window.location.pathname) && shouldUseReferrerReturnPath(navigationEntry === null || navigationEntry === void 0 ? void 0 : navigationEntry.type)) {
      rememberViewerReturnPath(getReferrerReturnPath(document.referrer, window.location.origin));
    }
    var onRouteChangeStart = function onRouteChangeStart(url) {
      var nextPathname = new URL(url, window.location.origin).pathname;
      var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search;
      if (isViewerPath(nextPathname) && !isViewerPath(pathname)) {
        rememberViewerReturnPath("".concat(pathname).concat(search));
      }
    };
    router.events.on("routeChangeStart", onRouteChangeStart);
    return function () {
      return router.events.off("routeChangeStart", onRouteChangeStart);
    };
  }, [router.events]);
}
export default useViewerReturnPath;